import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Category = styled.li`
  width: 17.5%;
  a {
    display: block;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    text-decoration: none;
    color: #333;
    border-radius: 10px;
    border: solid 3px #fff;
    &:hover {
      border: solid 3px ${props => props.theme.colors.highlight};
    }
  }
  img {
    width: 70px;
    height: 70px;
    margin: 0 auto;
  }
  h3 {
    padding: 0;
    margin: 9px 0 0 0;
    font-size: 18px;
    letter-spacing: 0.07em;
    font-weight: normal;
  }
  @media screen and (max-width: 850px) {
    a {
      padding: 15px 0;
    }
    h3 {
      font-size: 16px;
    }
    img {
      width: 50px;
      height: 50px;
    }
  }
  @media screen and (max-width: 700px) {
    a {
      padding: 10px 0;
    }
    h3 {
      font-size: 13.5px;
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
  @media screen and (max-width: 550px) {
    a {
      padding: 6px 0;
    }
    h3 {
      font-size: 11px;
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
  @media screen and (max-width: 450px) {
    a {
      padding: 5px 0;
    }
    h3 {
      margin-top: 4px;
      font-size: 10px;
    }
    img {
      width: 30px;
      height: 30px;
    }
  }
`

const Title = styled.h3`
  font-size: 1.5em;
  font-weight: 600;
  text-transform: capitalize;
  margin: 1rem 1rem 0.5rem 1rem;
`

const CategoryCard = ({ url, title, imageSrc }) => {
  return (
    <Category className="webfont">
      <Link to={`/${url}/`}>
        <img src={imageSrc} />
        <Title>{title}</Title>
      </Link>
    </Category>
  )
}

export default CategoryCard
